import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-general-enquiry',
  templateUrl: './general-enquiry.component.html',
  styleUrls: ['./general-enquiry.component.scss']
})
export class GeneralEnquiryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
